enum NotificationViewMode {
  ALL = "all",
  MENTIONS = "mentions",
}

export default NotificationViewMode;
